import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

import * as Style from "../styledComponents/PersonalInstruction";
import { Icon } from "antd";
import DEATH_API from "../../apis/death.api";
import PhoneNumber from "../../components/form/components/Countrycode";
import Loader from "../../components/styled-components/loader/loader";
import "./profilepage.css";
import swal from "sweetalert";

export const ProfilePage = () => {
  const [formData, setFormData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [formData2, setFormData2] = useState(null);
  const location = useLocation();

  const handlechange = (name, value) => {
    // e.preventDefault();
    setFormData({
      ...formData,
      [name]: value,
    });
    setFormData2({
      ...formData2,
      [name]: value,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Submit...", formData2);
    try {
      let playload = {};
      playload = {
        name: formData && formData.name,
        userName: formData && formData.userName,
        email: formData && formData.email,
        phoneNumber: formData && formData.phoneNumber,
        zipCode: formData && +formData.zipCode,
        password: formData && formData.password,
      };
      setLoading(true);
      console.log("obj in playload update", playload);
      const response = await DEATH_API.updateProfileData(playload);
      console.log("response", response);
      if (response.status === 200) {
        swal("Success", response.message, "success");
      }
      if (response.status === 400) {
        swal("Oops!", response.message, "error");
      }
      setLoading(false);
      setFormData(null);
      getProfileDetails();
    } catch (error) {
      console.log("error in update", error);
      setLoading(false);
    }
  };

  const getProfileDetails = async () => {
    try {
      //   setFormData(null);
      setLoading(true);
      let data = await DEATH_API.getProfileData();
      setLoading(false);
      if (data && data.data) {
        data.data.phoneNumber = `${data.data.countryCode} ${data.data.phoneNumber}`;
        setFormData(data.data);
      }
      if (data && data.data) {
        localStorage.setItem("User", data.data.name);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    if (
      !(location.pathname === "Login") &&
      !(location.pathname === "Otp") &&
      !(location.pathname === "Logout") &&
      !(location.pathname === "Forget Password") &&
      !(location.pathname === "Confirm") &&
      !(location.pathname === "Signup") &&
      !(location.pathname === "TrusteeLogin") &&
      !(location.pathname === "Accept Invitation") &&
      !(location.pathname === "Payment")
    ) {
      // getUserRole();
      console.log("dasdasdasd");
      getProfileDetails();
    }
  }, []);
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  return (
    <div>
      <div className="profileMain">
        {userRole && (userRole === "trustee" || userRole === "protrustee") ? (
          <form style={{ width: "35%", marginLeft: "2rem" }}>
            <h1 className="MainProfileHeading">Profile Settings</h1>

            <div style={{ marginTop: "8px" }}>
              <Style.FieldsTitle>Name</Style.FieldsTitle>
              <Style.Input
                disabled={true}
                style={{ width: "100%" }}
                placeholder="Name"
                type="text"
                value={formData && formData.name}
                onChange={(e) => {
                  e.preventDefault();
                  handlechange(e.target.name, e.target.value);
                }}
                name="name"
              />
            </div>
            <div style={{ marginTop: "8px" }}>
              <Style.FieldsTitle>Email</Style.FieldsTitle>
              <Style.Input
                disabled={true}
                style={{ width: "100%" }}
                placeholder="Email"
                type="email"
                value={formData && formData.email}
                onChange={(e) => {
                  e.preventDefault();
                  handlechange(e.target.name, e.target.value);
                }}
                name="email"
              />
            </div>
            <div style={{ marginTop: "8px" }}>
              <Style.FieldsTitle>Phone Number</Style.FieldsTitle>
              {formData && (
                <PhoneNumber
                  disabled={true}
                  style={{ width: "100%" }}
                  placeholder="Phone Number"
                  value={formData && formData.phoneNumber}
                  onChange={(e) => {
                    // e.preventDefault();
                    handlechange("phoneNumber", e.target.value);
                  }}
                  name="phoneNumber"
                />
              )}
            </div>
          </form>
        ) : (
          <form style={{ width: "35%", marginLeft: "2rem" }}>
            <h1 className="MainProfileHeading">Profile Settings</h1>

            <div style={{ marginTop: "8px" }}>
              <Style.FieldsTitle>Name</Style.FieldsTitle>
              <Style.Input
                style={{ width: "100%" }}
                placeholder="Name"
                type="text"
                value={formData && formData.name}
                onChange={(e) => {
                  e.preventDefault();
                  handlechange(e.target.name, e.target.value);
                }}
                name="name"
              />
            </div>
            <div style={{ marginTop: "8px" }}>
              <Style.FieldsTitle>Username</Style.FieldsTitle>
              <Style.Input
                style={{ width: "100%" }}
                placeholder="Username"
                type="text"
                value={formData && formData.userName}
                onChange={(e) => {
                  e.preventDefault();
                  handlechange(e.target.name, e.target.value);
                }}
                name="userName"
              />
            </div>
            <div style={{ marginTop: "8px" }}>
              <Style.FieldsTitle>Email</Style.FieldsTitle>
              <Style.Input
                style={{ width: "100%" }}
                placeholder="Email"
                type="email"
                value={formData && formData.email}
                onChange={(e) => {
                  e.preventDefault();
                  handlechange(e.target.name, e.target.value);
                }}
                name="email"
              />
            </div>
            <div style={{ marginTop: "8px" }}>
              <Style.FieldsTitle>Phone Number</Style.FieldsTitle>
              {formData && (
                <PhoneNumber
                  style={{ width: "100%" }}
                  placeholder="Phone Number"
                  value={formData && formData.phoneNumber}
                  onChange={(e) => {
                    // e.preventDefault();
                    handlechange("phoneNumber", e.target.value);
                  }}
                  name="phoneNumber"
                />
              )}
            </div>
            <div style={{ marginTop: "8px" }}>
              <Style.FieldsTitle>Zip Code</Style.FieldsTitle>
              <Style.Input
                style={{ width: "100%" }}
                placeholder="Zip Code"
                type="text"
                value={formData && formData.zipCode}
                onChange={(e) => {
                  e.preventDefault();
                  handlechange(e.target.name, e.target.value);
                }}
                name="zipCode"
              />
            </div>
            <div style={{ marginTop: "8px" }}>
              <Style.FieldsTitle>Password</Style.FieldsTitle>
              <div
                style={{
                  border: " 1px solid #d1d5db",
                  borderRadius: "5px",
                  display: "flex",
                }}>
                <Style.Input
                  style={{
                    width: "100%",
                    border: "none",
                    paddingInline: "10px",
                    paddingBottom: "4px",
                  }}
                  placeholder="Password"
                  type={showPassword ? "text" : "password"}
                  value={formData && formData.password}
                  onChange={(e) => {
                    e.preventDefault();
                    handlechange(e.target.name, e.target.value);
                  }}
                  name="password"
                />
                <Icon
                  type={showPassword ? "eye-invisible" : "eye"}
                  style={{ padding: "12px", fontSize: "18px" }}
                  onClick={() => {
                    setShowPassword(!showPassword);
                  }}
                />
              </div>
            </div>
            <Style.WrapperButtons>
              <Style.SaveButton1 onClick={handleSubmit}>
                Save Changes
              </Style.SaveButton1>
              <Style.CancelButton1
                onClick={(e) => {
                  e.preventDefault();
                  getProfileDetails();
                }}>
                Cancel
              </Style.CancelButton1>
            </Style.WrapperButtons>
          </form>
        )}
      </div>
      <Loader isLoading={loading} />
    </div>
  );
};
